import { Flex } from '@chakra-ui/react';
import { FC } from 'react';

import { EventSessionsDropdown } from '@/components/event/EventSessionsDropdown';
import { EventSearchInput } from '@/components/ui/features/events-list/EventSearchInput/EventSearchInput';
import {
  ScheduleTrackFilter,
  TrackFilterScope,
} from '@/components/ui/features/schedule/ScheduleTrackFilter/ScheduleTrackFilter';
import { SessionTagFilter } from '@/components/ui/features/session/SessionTagFilter/SessionTagFilter';
import { SearchCategories } from '@/enums';

export const PostersHeaderDesktop: FC = () => {
  return (
    <Flex
      display={{ base: 'none', lg: 'flex' }}
      flexDirection={{ base: 'column-reverse', md: 'row' }}
      w="full"
      justifyContent="flex-end"
      gap={4}
    >
      <SessionTagFilter sessionPosterOnly="true" />
      <ScheduleTrackFilter scope={TrackFilterScope.Posters} />
      <EventSessionsDropdown scope={SearchCategories.POSTERS} />
      <EventSearchInput w="full" maxW={{ lg: '450px' }} isPoster={true} />
    </Flex>
  );
};
